import AdditionalBaggage from './components/AdditionalBaggage.css';
import PromoMessage from './components/PromoMessage/PromoMessage.css';
import Footer from './components/Footer/Footer.css';

export default {
	AdditionalBaggage,
	PromoMessage,
	Footer
};
